import React from 'react';
import styles from './css/Hero.styl';
import sharedStyles from '../../css/Shared.styl';
import {bgStyles, GuideImage} from './css/assets';
import PlanningGuideLeadForm from '../../../../shared/PlanningGuideLeadForm';
import classnames from 'classnames';

const cx = classnames.bind(styles);

const HeroAlternate = () => {
  const classes = {
    HeroBlock: true,
    Alternate: true,
  };

  return (
    <div className={cx(classes)} style={bgStyles}>
      <div className={sharedStyles.Wrap}>
        <div className={styles.HeroHeading}>
          <h1 className={styles.Title}>
            Get Answers About Planning&nbsp;Ahead
          </h1>
          <h2 className={styles.SubTitle}>
            Download your free funeral planning guide&nbsp;&amp;&nbsp;checklist
          </h2>
        </div>
        <div className={styles.HeroContent}>
          <div className={styles.HeroInner}>
            <div className={styles.Form}>
              <PlanningGuideLeadForm
                webcollectKey="ECC651A8-1542-47A9-83A5-98E1CFDC788E"
                theme="dark"
                visibleFields={[
                  'firstName',
                  'lastName',
                  'email',
                  'zipCode',
                  'phoneNumber',
                ]}
              />
            </div>
          </div>
          <div className={styles.Image}>
            <img
              src={GuideImage['1x']}
              alt="Your Guide to Planning Ahead thumbnail"
              srcSet={`${GuideImage['2x']} 2x, ${GuideImage['3x']} 3x`}
              sizes="527px"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroAlternate;



// WEBPACK FOOTER //
// ./src/reactModules/pages/GeneralPlanning/components/Hero/alternate.js